export var BlendType;

(function (BlendType) {
  BlendType["normal"] = "normal";
  BlendType["additive"] = "additive";
  BlendType["subtractive"] = "subtractive";
  BlendType["min"] = "min";
  BlendType["max"] = "max";
  BlendType["none"] = "none";
})(BlendType || (BlendType = {}));
//# sourceMappingURL=ILayerService.js.map